import { useRef, useCallback, useState } from "react";
import Webcam from "react-webcam";
import { Box, FeedbackBlock } from "@dbn/omnichannel-design-system-g4p";
import * as classes from "./TakePhoto.css";
import { useFormatMessage } from "../../../intl";
import { option } from "fp-ts";

type Props = {
  onContinue: (imgSource: string) => void;
};

export const TakePhoto = (props: Props) => {
  const videoConstraints = {
    width: { ideal: 1920 },
    height: { ideal: 1080 },
    facingMode: { ideal: "environment" },
  };
  const formatMessage = useFormatMessage();
  const [permissionDenied, setPermissionDenied] = useState<boolean>(false);
  const webcamRef = useRef<Webcam>(null);

  const capture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) props.onContinue(imageSrc);
    }
  }, [webcamRef]);

  // TODO @Mirel: check why TakePhoto.treat.ts is not applied correctly

  return permissionDenied ? (
    <FeedbackBlock
      size={"large"}
      heading={formatMessage(
        "Identification.UploadDocuments.mobileCheck.cameraDisabledTitle"
      )}
      subheading={option.some(
        formatMessage(
          "Identification.UploadDocuments.mobileCheck.cameraDisabledDescription"
        )
      )}
      type={"negative"}
      actions={[]}
    />
  ) : (
    <>
      <Box hAlignContent="center" vAlignContent="center" column grow shrink>
        <Webcam
          style={{ position: "absolute", left: 0, top: 0 }}
          className={classes.webcam}
          audio={false}
          forceScreenshotSourceSize
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          width={window.innerWidth}
          videoConstraints={videoConstraints}
          onUserMedia={media => console.log("success", media)}
          onUserMediaError={mediaStreamError => {
            console.log("error", mediaStreamError);
            if (mediaStreamError.toString().startsWith("NotAllowedError")) {
              setPermissionDenied(true);
            }
          }}
        />
        <Box
          onClick={capture}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              capture();
            }
          }}
          className={classes.captureButton}
          hAlignContent="center"
          vAlignContent="center"
          tabIndex={0}
        >
          <Box className={classes.captureButtonInside} />
        </Box>
      </Box>
    </>
  );
};
